// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xmw5uG {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3) 0;
  height: 100%;
  background-color: var(--background-alt);
}

.dOr3Cg {
  display: flex;
  gap: var(--spacing-3);
  flex: 1;
  align-items: stretch;
  min-height: 0;
}

.dOr3Cg.ScDH9H {
  justify-content: center;
}

.dOr3Cg.ScDH9H .VqadaB {
  max-width: 1200px;
}

.VqadaB {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.vTWR8l {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}

@media (max-width: 1024px) {
  .dOr3Cg {
    flex-direction: column;
  }

  .vTWR8l {
    width: 100%;
    order: -1;
  }
}

@media (max-width: 768px) {
  .xmw5uG {
    padding: var(--spacing-2);
    gap: var(--spacing-2);
  }

  .dOr3Cg {
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".contentLayout {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3) 0;\n  height: 100%;\n  background-color: var(--background-alt);\n}\n\n.cardsContainer {\n  display: flex;\n  gap: var(--spacing-3);\n  flex: 1;\n  align-items: stretch;\n  min-height: 0;\n}\n\n.cardsContainer.singleColumn {\n  justify-content: center;\n}\n\n.cardsContainer.singleColumn .mainCard {\n  max-width: 1200px;\n}\n\n.mainCard {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.sidebarCard {\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n}\n\n@media (max-width: 1024px) {\n  .cardsContainer {\n    flex-direction: column;\n  }\n\n  .sidebarCard {\n    width: 100%;\n    order: -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .contentLayout {\n    padding: var(--spacing-2);\n    gap: var(--spacing-2);\n  }\n\n  .cardsContainer {\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentLayout": `xmw5uG`,
	"cardsContainer": `dOr3Cg`,
	"singleColumn": `ScDH9H`,
	"mainCard": `VqadaB`,
	"sidebarCard": `vTWR8l`
};
module.exports = ___CSS_LOADER_EXPORT___;
